<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
               <el-form-item label="找车时间:" prop="createTimes">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
            </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="driverName" :formatter="emptyFn" label="司机姓名"></el-table-column>
        <el-table-column prop="tenantName"  min-width="150" :formatter="emptyFn" label="租户名称"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="找车时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { carSearchRecord } from '@/api/vgs-driver2.0'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        createTimes: null
      },
      total: 0,
      loading: 'false',
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      carSearchRecord(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null
      }
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
